import React from 'react';
import Icon from 'components/lib/icons/icon';

/**
 * @visibleName Edit Pencil
 */

export default function EditPencil(props) {
  return (
    <Icon viewBox="0 0 16 16" {...props}>
      <svg fill="none" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
        <rect
          fill="#9C9C9C"
          height="12"
          rx="0.5"
          transform="rotate(45 12.0205 0.707031)"
          width="4"
          x="12.0205"
          y="0.707031"
        />
        <path
          d="M2.12109 12.935V10.3995C2.12109 9.95404 2.65966 9.73095 2.97465 10.0459L5.51018 12.5815C5.82516 12.8965 5.60208 13.435 5.15663 13.435L2.62109 13.435C2.34495 13.435 2.12109 13.2112 2.12109 12.935Z"
          fill="#9C9C9C"
        />
      </svg>
    </Icon>
  );
}
